export default {
  radial: "radial",
  linear: "linear"
} as GradientTypes;
